<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import Link from "./Link.svelte";
	import translations from "./HomepageBanner.translations.json";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import { solutionsPathMap } from "../../../core/schema/paths/solutionsPathMap.js";
	import heroPoster from "../assets/images/homepage/hero-thumb.png?w=880&format=webp&imagetools";
	import { getTenant } from "../getTenant.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import heroVideo from "../assets/videos/hero-video.mp4";

	const tenant = getTenant();
	const translate = getTranslate(translations);
</script>

<div class="relative mx-auto mb-4 flex w-full gap-2">
	<div class="h-80 sm:h-[25rem] lg:h-full">
		<video
			poster={heroPoster}
			autoplay
			muted
			loop
			playsinline
			class="absolute inset-0 size-full max-w-[initial] object-cover"
			><source src={heroVideo} type="video/mp4" /><source src={heroVideo} type="video/webm" /></video
		>
	</div>
	<div class="absolute inset-0 z-10 bg-black/25"></div>
	<div
		class="z-20 flex w-full flex-col gap-10 px-6 py-[7.5rem] pb-0 sm:gap-16 sm:px-0 md:px-12 md:py-[9.25rem] md:pb-[4.25rem] lg:px-24 xl:px-32"
	>
		<div class="flex flex-col gap-4 bg-black/5 p-1 sm:contents">
			<h1
				aria-label={translate("fullTitle")}
				class="font-roboto flex flex-col pt-0 text-[9.5vw]/none font-light uppercase tracking-[-0.02em] text-white md:text-[9vw] lg:text-[8vw] 2xl:text-[10rem]"
			>
				<span>{nbspify(translate("titleAutomatization"))}</span>
				<span class="self-end">{nbspify(translate("titleFuture"))}</span>
				<span>{nbspify(translate("titleLogistics"))}</span>
			</h1>
			<div class="flex w-full items-center sm:min-h-48">
				<div class="font-lexend sm:text-2md/normal text-md/snug w-full max-w-[38.6875rem] font-bold text-white">
					{translate("content")}
				</div>
			</div>
		</div>
		<div class="mb-6 flex w-full flex-col gap-4 md:mb-0 md:w-fit md:flex-row">
			<Link asButton variant="primary" icon={arrowRight} href="/{solutionsPathMap[tenant.locale]}">
				{translate("primaryBtn")}
			</Link>
			<Link asButton variant="secondaryTransparent" icon={arrowRight} href="#contact-form">
				{translate("secondaryBtn")}
			</Link>
		</div>
	</div>
</div>
